const getDefault = () => {
  return {
    folderId: '',
    originalFileName: '',
    details: {},
    flatteningResult: [],
    result: [],
    valid: false,
    approvePrinting: false,
    previewUrl: '',
    mailoutName: '',
    productId: '',
    deliveryId: '',
    recipientsData: {},
    isCostEstimate: undefined,
    selectedUploadOption: null,
    showInvalidatedMaterialMsg: false,
    letterOptions: {
      printType: 'single-sided',
      mailoutName: '',
      includePreface: false,
      includePaymentSlip: false,
      optionalPageCount: 1,
      optionalRecipientsCount: 1,
      optionalLatePayment: false,
      optionalDeliveryOption: 'economy'
    }
  }
}

export default {
  namespaced: true,
  state: Object.assign({}, getDefault()),
  getters: {
    getResultErrors: state => {
      return state.result.filter(res => res.valid === 2)
    },
    getResultWarnings: state => {
      const fromResult = state.result.filter(res => res.valid === 3)
      const fromFlatteningResult = state.flatteningResult.filter(
        res => res.valid === 3
      )

      return fromResult.concat(fromFlatteningResult)
    },
    hasTransparentImagesWarning: (state, getters) => {
      const warnings = getters.getResultWarnings

      return warnings.some(
        x => x.label.key === 'W2P_UPLOAD_MATERIAL_WARN_IMAGE_TRANSPARENT'
      )
    },
    hasLowImageResoWarning: (state, getters) => {
      const warnings = getters.getResultWarnings

      return warnings.some(
        x => x.label.key === 'W2P_UPLOAD_MATERIAL_WARN_IMAGE_RESOLUTION'
      )
    },
    hasDisallowedElementsWarning: (state, getters) => {
      const warnings = getters.getResultWarnings

      return warnings.some(
        x => x.label.key === 'W2P_UPLOAD_MATERIAL_WARN_DISALLOWED_ELEMENTS'
      )
    },
    hasDisallowedFontsWarning: (state, getters) => {
      const warnings = getters.getResultWarnings

      return warnings.some(
        x => x.label.key === 'W2P_UPLOAD_MATERIAL_WARN_DISALLOWED_FONTS'
      )
    },
    getDisallowedFonts: (state, getters) => {
      const warnings = getters.getResultWarnings

      return warnings.filter(
        x => x.label.key === 'W2P_UPLOAD_MATERIAL_WARN_DISALLOWED_FONTS'
      )
    },
    getProductOptions: state => {
      return {
        productId: state.productId,
        deliveryId: state.deliveryId,
        recipientsData: state.recipientsData
      }
    },
    getComputedNumberOfPages: state => {
      let numberOfPages = state.details.numberOfPages
        ? state.details.numberOfPages.current
        : 1

      if (
        state.letterOptions.includePreface &&
        state.letterOptions.printType === 'single-sided'
      ) {
        numberOfPages++
      }

      if (
        state.letterOptions.includePreface &&
        state.letterOptions.printType !== 'single-sided'
      ) {
        numberOfPages = numberOfPages + 2
      }

      if (state.letterOptions.printType !== 'single-sided') {
        numberOfPages = Math.round(numberOfPages / 2)
      }

      return numberOfPages
    }
  },
  mutations: {
    SAVE_MATERIAL(state, data) {
      state = Object.assign(state, { ...data })
    },
    // eslint-disable-next-line no-unused-vars
    RESET_STATE_ALL(state) {
      state = Object.assign(state, getDefault())
    },
    // eslint-disable-next-line
    RESET_MATERIAL(state) {
      state = Object.assign(state, {
        folderId: '',
        originalFileName: '',
        details: {},
        flatteningResult: [],
        result: [],
        valid: false,
        approvePrinting: false,
        previewUrl: null
      })
    },
    SET_MATERIAL(state, params) {
      state[params.key] = params.value
    },
    TOOGLE_MATERIAL_APPROVE_PRINTING(state) {
      state.approvePrinting = !state.approvePrinting
    },
    UPDATE_LETTER_OPTIONS: (state, options) => {
      if (options.productId) {
        state.productId = options.productId
      }
      if (options.deliveryId) {
        state.deliveryId = options.deliveryId
      }
      if (options.recipientsData) {
        state.recipientsData = options.recipientsData
      }
      if (options.mailoutName) {
        state.mailoutName = options.mailoutName
      }
      if (options.letterOptions) {
        state.letterOptions = options.letterOptions
      }
    },
    UPDATE_PRODUCT_ID: (state, productId) => {
      state.productId = productId
    },
    UPDATE_DELIVERY_ID: (state, deliveryId) => {
      state.deliveryId = deliveryId
    },
    UPDATE_RECIPIENTS_DATA: (state, recipientsData) => {
      state.recipientsData = recipientsData
    },
    TOGGLE_COST_ESTIMATE: state => {
      state.isCostEstimate = !state.isCostEstimate
    },
    SET_COST_ESTIMATE: (state, isCostEstimate) => {
      state.isCostEstimate = isCostEstimate
    }
  }
}
